<template>
  <el-container>
    <el-aside width="200px" class="bg-[#545c64] h-[100vh]">
      <el-menu
        :default-active="$route.path"
        class="border-r-0"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#1989fa"
        router
      >
        <el-menu-item index="/appList">
          <i class="el-icon-s-platform"></i>
          <span slot="title">应用程序管理</span>
        </el-menu-item>
        <el-menu-item index="/smsSign">
          <i class="el-icon-edit"></i>
          <span slot="title">短信签名管理</span>
        </el-menu-item>
        <el-menu-item index="/smsRecord">
          <i class="el-icon-s-order"></i>
          <span slot="title">发送记录查询</span>
        </el-menu-item>
        <el-menu-item index="/smsCount">
          <i class="el-icon-s-data"></i>
          <span slot="title">发送量统计</span>
        </el-menu-item>
        <el-menu-item index="/ipConfig">
          <i class="el-icon-s-claim"></i>
          <span slot="title">IP白名单管理</span>
        </el-menu-item>
        <el-menu-item index="/phoneBlacklist">
          <i class="el-icon-warning"></i>
          <span slot="title">手机号黑名单</span>
        </el-menu-item>
        <el-menu-item index="/smsTest">
          <i class="el-icon-s-promotion"></i>
          <span slot="title">发送短信测试</span>
        </el-menu-item>
        <el-menu-item index="/vendorConfig">
          <i class="el-icon-setting"></i>
          <span slot="title">厂商管理</span>
        </el-menu-item>
        <el-menu-item index="/vendorAlert">
          <i class="el-icon-bell"></i>
          <span slot="title">告警记录</span>
        </el-menu-item>
        <el-menu-item index="/dlqMessage">
          <i class="el-icon-message-solid"></i>
          <span slot="title">死信消息管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="bg-white flex justify-between items-center">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-dropdown>
          <span class="el-dropdown-link">
            <span class="mr-2">admin</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      title: "应用程序管理",
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.title = val.meta.title;
      },
    },
  },
  methods: {
    logout() {
      this.$confirm("是否确认退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.clear();
          window.location.reload();
        })
        .catch(() => {});
    },
  },
};
</script>
